module.exports = __webpack_public_path__ + "static/media/xas.2e1a5a03.svg";